import React, {useEffect, useState} from 'react';

import Page from "../Components/Page";
import {Breadcrumbs} from "../Components/Breadcrumbs";
import {makeApiCall, makeApiCallPost} from "../../Api/makeApiCall";
import ReactTable from "../Components/ReactTable";
import RetailerIdAndName from "../Components/RetailerIdAndName";
import {getRetailerName} from "../../utils/localCache/retailerMapCache";
import UnmappedStoresFileDetails from "./UnmappedStoresFileDetails";
import {AddSupplementalStore} from "./AddSupplementalStore";
import {IgnoreUnmappedStores} from "./IgnoreUnmappedStores";
import {LoadingWrapper} from "../Components/LoadingWrapper";
import PropTypes from "prop-types";
import {createDagRunConf} from "../../Api/dagRunConf";
import ButtonLoader from "../../utils/components/ButtonLoader";


export const UNMAPPED_STORES_COLUMNS = [
    {
        header: 'Retailer',
        accessorKey: 'retailerId',
        filterable: true,
        cell: ({row}) => <RetailerIdAndName retailerId={row.original.retailerId}/>,
        minSize: 100,
        filterFn: (row, columnIds, filterValue) => {
            return !filterValue || Boolean(`${row.original.retailerId} ${getRetailerName(row.original.retailerId)?.toLowerCase()}`.includes(filterValue.toLowerCase()));
        }
    },
    {
        header: 'File Name',
        accessorKey: 'fileName',
        minSize: 200
    },
    {
        header: 'Dates',
        accessorKey: 'fileDetails',
        cell: UnmappedStoresFileDetails,
        minSize: 100,
        enableColumnFilter: false
    },
    {
        header: 'Add Mapping',
        cell: AddSupplementalStore,
        minSize: 300
    },
    {
        header: 'Ignore',
        cell: IgnoreUnmappedStores,
        minSize: 100
    }
];

export function UnmappedStores({displayHelmetHeader = true, retailChain, retailerId}) {

    const endpointBase = `${process.env.REACT_APP_EDP_API_BASE_URL}/unmappedStores/`;

    const [data, setData] = useState(undefined);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        setLoading(true);
        const endpoint = retailerId ? `${endpointBase}?retailerId=` + retailerId : `${endpointBase}`;
        makeApiCall(endpoint)
            .then((results) => setData(results.metadata))
            .finally(() => setLoading(false));
    }, [retailerId])

    return (
        <Page name="Unmapped Stores" breadCrumbs={<Breadcrumbs items={[{label: "Unmapped"}, {label: "Stores"}]}/>} displayHelmetHeader={displayHelmetHeader}>
            <LoadingWrapper loading={loading}>
                {retailerId && <ButtonLoader
                    buttonClassName={'button alert'}
                    buttonTitle={'Reload Unmapped Stores'}
                    buttonHasModal
                    modalHeader={'Reload Unmapped Stores'}
                    userAcknowledgedCheck
                    modalText={`this cannot be undone`}
                    axiosFunction={makeApiCallPost}
                    url={`${process.env.REACT_APP_EDP_API_BASE_URL}/dagTrigger`}
                    postBody={{
                        dagName: 'reingest_unmapped_stores',
                        data: createDagRunConf({retailer_id: retailerId})
                    }}
                    toastTextFailure={`Reloading of unmapped stores for ${retailChain} has failed to kicked off.`}
                    toastTextSuccess={`Reloading of unmapped stores for ${retailChain} has successfully kicked off.`}
                />}
                {data && <ReactTable
                    filterable={true}
                    data={data}
                    columns={UNMAPPED_STORES_COLUMNS}
                />}
            </LoadingWrapper>
        </Page>
    );
}

UnmappedStores.propTypes = {
    displayHelmetHeader: PropTypes.bool,
    retailChain: PropTypes.string,
    retailerId: PropTypes.number,
};

export default UnmappedStores;
